// import { ConfirmationEvent } from '@/components/Confirmation/ConfirmationEventBus';
// import PageService from '@/services/Archiving/InstancePageService';
// import UploadService from '@/services/Archiving/UploadService';

export default {
  // getUploadedFiles({ instanseId, treeId, keyword }) {
  //   if (instanseId) {
  //     return PageService.getPages({
  //       treeId: treeId,
  //       instanceId: instanseId,
  //       keyWord: keyword ? keyword : ''
  //     });
  //   }
  // },
  // saveFile(body) {
  //   return PageService.savePage(body, body.treeId);
  // },
  uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    );
  },
  fileMimeTypeChecker(fileMimeType) {
    if (!fileMimeType) return { iconUrl: '/upload-icons/unknown.png', mimeType: 'Unknown' };
    if (fileMimeType.includes('image')) return { iconUrl: '/upload-icons/Gallery.png', mimeType: 'Image' };
    if (fileMimeType.includes('video')) return { iconUrl: '/upload-icons/avi.png', mimeType: 'Video' };
    if (fileMimeType.includes('audio')) return { iconUrl: '/upload-icons/mp3.png', mimeType: 'Audio' };
    if (fileMimeType.includes('compressed')) return { iconUrl: '/upload-icons/zip.png', mimeType: 'Compressed' };
    if (fileMimeType.includes('word')) return { iconUrl: '/upload-icons/word.png', mimeType: 'Word' };
    if (fileMimeType.includes('presentation') || fileMimeType.includes('powerpoint'))
      return { iconUrl: '/upload-icons/powerpoint.png', mimeType: 'PresentationAndPowerpoint' };
    if (fileMimeType.includes('excel') || fileMimeType.includes('sheet'))
      return { iconUrl: '/upload-icons/excel.png', mimeType: 'ExcelAndSheet' };
    if (fileMimeType.includes('pdf')) return { iconUrl: '/upload-icons/pdf.png', mimeType: 'Pdf' };
    if (fileMimeType.includes('html')) return { iconUrl: '/upload-icons/html.png', mimeType: 'Html' };
    if (fileMimeType.includes('text') || fileMimeType.includes('txt')) return { iconUrl: '/upload-icons/file.png', mimeType: 'Text' };
    if (fileMimeType.includes('exe')) return { iconUrl: '/upload-icons/exe.png', mimeType: 'Exe' };
    return { iconUrl: '/upload-icons/unknown.png', mimeType: 'Unknown' };
  }
};
